import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalHelperService } from '../services/msal-helper.service';
import { FlowManagementService } from '../services/flow-management.service';
import { flatMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.css'],
    standalone: false
})
export class DebugComponent implements OnInit {

  public solutions: any[] = [];
  public flows: any[] = [];
  public error: any = null;
  public debug = window.location.host.startsWith('localhost');

  public token_flow;
  public token_flow_a;
  public token_pa;

  public debug1: any = null;
  public debug3: string = '';
  public debug4: any = null;
  public debug5: any = null;
  public debug6: any = null;

  constructor(private msalHelperService: MsalHelperService, private flowManagementService: FlowManagementService, private http: HttpClient) { }

  ngOnInit() {
    this.token_flow = this.msalHelperService.getCachedTokenInternal(['https://service.flow.microsoft.com//Flows.Manage.All']);
    this.token_flow_a = this.msalHelperService.getCachedTokenInternal(['https://service.flow.microsoft.com//User']);
    this.token_pa = this.msalHelperService.getCachedTokenInternal(['https://service.powerapps.com/User']);

    this.debug1 = this.msalHelperService.getUser();
    this.debug3 = this.flowManagementService.currentEnvironment;
    this.debug4 = this.flowManagementService.currentEnvironment$;
    this.debug5 = this.msalHelperService.error;
    this.debug6 = this.msalHelperService.getCachedTokenInternal(['https://services.crm.dynamics.com/user_impersonation']);
  }

  /** Returns expiry info for a cached token object. null = no token. */
  tokenExpiry(token: any): { iso: string; expired: boolean } | null {
    if (!token?.secret) return null;
    try {
      const exp = this.decodeJwtPayload(token.secret)?.exp;
      if (!exp) return null;
      return { iso: new Date(exp * 1000).toISOString(), expired: exp < Math.floor(Date.now() / 1000) };
    } catch { return null; }
  }

  private decodeJwtPayload(token: string): any | null {
    const parts = token.split('.');
    if (parts.length < 2 || !parts[1]) return null;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const bytes = Uint8Array.from(atob(padded), c => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  login() {
    this.msalHelperService.login();
  }

  // get debug2a() {
  //   let token2 = this.msalHelperService.getCachedTokenInternal(['https://service.powerapps.com/User']);

  //   // if (!token) {
  //   //   token = this.msalHelperService.getCachedTokenInternal(['https://management.azure.com/user_impersonation']);
  //   // }
  //   return token2;
  // }

  // get debug2alink() {
  //   return `https://jwt.ms/#access_token=${this.debug2a?.token}`;
  // }

  relogin() {
    this.msalHelperService.logout();
    //this.msalHelperService.login();
  }

  loginPowerAdmin() {
    this.msalHelperService.loginPowerAdmin();
  }

  loginConsent() {
    this.msalHelperService.loginPowerConsent();
  }

  loginPowerAppConsent() {
    this.msalHelperService.loginPowerAppConsent();
  }

  getSolutions() {
    this.flowManagementService.getSolutions(this.flowManagementService.currentEnvironment).toPromise().then(res=>{
      this.solutions = res.value.filter(solution=>solution.isvisible);
    }, reason => {
      this.error = reason;
    })
  }

  getSolutionFlows() {
    //https://org9ef703f1.crm6.dynamics.com/api/data/v9.0/msdyn_solutioncomponentsummaries?%24filter=(msdyn_solutionid%20eq%20beb22393-dc66-e911-a97e-000d3ad1c0d2)
    this.flowManagementService.getSolutionFlows(this.flowManagementService.currentEnvironment).toPromise().then(res=>{
      this.flows = res
    }, reason => {
      this.error = reason;
    })
  }

  async loginDynamicsConsent() {

    let env = await this.flowManagementService.getEnvironment(this.flowManagementService.currentEnvironment).toPromise();

    //debugger;
    let url = env.properties.linkedEnvironmentMetadata.instanceApiUrl;
    this.msalHelperService.loginDynamicsConsent(url);


  }

  flowAuth() {
    this.msalHelperService.loginPowerConsent();
  }

  appAuth() {
    this.msalHelperService.loginPowerAppConsent();
  }

  // --- Subscription Check (flowstudio.app users only) ---
  public lookupQ: string = '';
  public lookupResult: any = null;
  public lookupError: any = null;
  public lookupBusy = false;

  get isFlowStudioStaff(): boolean {
    const u = this.msalHelperService.getUser();
    const name = (u?.username || '').toLowerCase();
    return name.endsWith('@flowstudio.app');
  }

  async runLookup() {
    this.lookupResult = null;
    this.lookupError = null;
    const q = (this.lookupQ || '').trim();
    if (!q) { this.lookupError = 'enter a value'; return; }
    this.lookupBusy = true;
    try {
      const token = this.token_flow?.secret || this.token_flow_a?.secret || this.token_pa?.secret || '';
      const url = `/api/debug-lookup?q=${encodeURIComponent(q)}`;
      this.lookupResult = await this.http.post(url, {}, {
        headers: token ? { 'x-authorization': `Bearer ${token}` } : {}
      }).toPromise();
    } catch (e: any) {
      this.lookupError = e?.error || e?.message || e;
    } finally {
      this.lookupBusy = false;
    }
  }

}
